/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

export default reEvaluate;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_reEvaluate.js
// module id = 2292
// module chunks = 67